module.exports = __webpack_public_path__ + "static/media/Schorey_Resume.ead15e87.pdf";